import { Component, Input } from '@angular/core';
import { Cms, ICarDetails } from '@impact/data';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { arrowRightIcon } from '../../icons';
import { SettingsService } from '../core/settings.service';
import { SidePanelService } from '../side-panel/side-panel.service';
import { UsedCarService } from '../used-car-details/used-car.service';

@Component({
    selector: 'app-book-used-car-test-drive-cta',
    template: `
        <ng-container *ngIf="car$ | async">
            <header class="section-header--centered">
                <h3 class="component-header--small" *ngIf="data?.bookTestDriveCtaCategoryHeaderText">
                    {{ data?.bookTestDriveCtaCategoryHeaderText }}
                </h3>
                <h2 class="section-header__text used-car-details-primary-heading">{{ data?.bookTestDriveCtaHeaderText }}</h2>
            </header>
            <p class="section-header__text--secondary" *ngIf="data?.bookTestDriveCtaText">
                {{ data?.bookTestDriveCtaText }}
            </p>

            <ul class="book-test-drive-cta__list" *ngIf="meetingOptions$ | async as options">
                <li class="book-test-drive-cta__list-item" *ngFor="let option of options; let i = index;">
                    <button class="book-test-drive-cta__button" (click)="openBookTestDriveSidePanel(option.header)">
                        <div class="book-test-drive-cta__button-content">
                            <div class="book-test-drive-cta__button-primary-text">{{option?.header}}</div>
                            <div class="book-test-drive-cta__button-secondary-text" *ngIf="option?.description">{{option.description}}</div>
                        </div>
                        <div class="book-test-drive-cta__button-icon-right">${arrowRightIcon}</div>
                    </button>
                </li>
            </ul>
        </ng-container>
    `
})

export class BookUsedCarTestDriveCtaComponent {
    @Input() data: Cms.BookUsedCarTestDriveCtaSpot;

    meetingOptions$: Observable<Cms.BookTestdriveMeetingOption[]>;
    car$: Observable<ICarDetails>;

    usedCarData: ICarDetails;

    constructor(
        private settingsService: SettingsService,
        private sidePanelService: SidePanelService,
        private usedCarService: UsedCarService,
    ) {
        this.car$ = this.usedCarService.carDetails$;

        this.meetingOptions$ = this.settingsService
            .get()
            .pipe(map(settings => settings.bookTestDriveMeetingOptions));
    }

    openBookTestDriveSidePanel(headerText: string) {
        this.sidePanelService.showBookUsedCarTestDriveSidePanel(this.car$, headerText);
    }
}
